import type { RouteRecordRaw } from 'vue-router'

export const vodMockupsRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('./layout/VodLayout.vue'),
    children: [
      {
        path: '',
        name: 'vod-home',
        component: () => import('./views/VodHomeView.vue'),
        meta: {
          title: 'AgriVidéo - Plateforme vidéo du Ministère de l\'Agriculture'
        }
      },
      {
        path: 'browse',
        name: 'vod-browse',
        component: () => import('./views/VodBrowseView.vue'),
        meta: {
          title: 'Médiathèque - AgriVidéo'
        }
      },
      {
        path: 'watch/:id',
        name: 'vod-watch',
        component: () => import('./views/VodDetailView.vue'),
        meta: {
          title: 'Visionnage - AgriVidéo'
        }
      },
      {
        path: 'collections',
        name: 'vod-collections',
        component: () => import('./views/VodCollectionsListView.vue'),
        meta: {
          title: 'Mes sélections - AgriVidéo'
        }
      },
      {
        path: 'collections/:collectionId',
        name: 'vod-collection-detail',
        component: () => import('./views/VodCollectionDetailView.vue'),
        meta: {
          title: 'Collection - AgriVidéo'
        }
      },
      {
        path: 'profile',
        name: 'vod-profile',
        component: () => import('./views/VodProfileView.vue'),
        meta: {
          title: 'Mon profil - AgriVidéo'
        }
      }
    ]
  }
]

export default vodMockupsRoutes
